import MediaPlanTargets from './MediaPlanTargets';

export default MediaPlanTargets;
